import { Component, OnInit } from '@angular/core';
import {UserGroupDetailsComponent} from '@spartacus/organization/administration/components';
import { EfaOrgCardComponent } from '../efa-org-card/efa-org-card.component';
import { FocusDirective } from '@spartacus/storefront';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe, UrlPipe } from '@spartacus/core';

@Component({
    selector: 'app-efa-user-group-details',
    templateUrl: './efa-user-group-details.component.html',
    imports: [EfaOrgCardComponent, FocusDirective, RouterLinkActive, RouterLink, AsyncPipe, TranslatePipe, UrlPipe]
})
export class EfaUserGroupDetailsComponent extends UserGroupDetailsComponent
{
}
